import React from "react"
import { BreadcrumbsContainer } from "./style"
import { Link } from "gatsby"

const Breadcrumbs = ({ data, title, blog }) => {
  console.log("data:", data)
  return (
    <BreadcrumbsContainer>
      <Link to="/">
        <span>></span> Home
      </Link>
      {data &&
        data.map((item, index) => {
          return (
            <Link key={index} to={item.link}>
              <span>></span>{" "}
              <p dangerouslySetInnerHTML={{ __html: item.title }} />
            </Link>
          )
        })}

      {blog && (
        <Link to="/life-at-auburn">
          <span>></span> Life at Auburn
        </Link>
      )}

      <Link to="/">
        <span>></span> <p dangerouslySetInnerHTML={{ __html: title }} />
      </Link>
    </BreadcrumbsContainer>
  )
}

export default Breadcrumbs
